import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App.js';

function checkForFirebase() {
  if (window.firebase && window.firebase.auth && window.firebase.firestore) {
    startApp();
  } else {
    setTimeout(checkForFirebase, 100);
  }
}

function startApp() {
  // Inicializa o Firebase AQUI, uma única vez.
  if (!firebase.apps.length) {
    const firebaseConfig = {
      apiKey: "AIzaSyDtCww7O4xpEnOkS135BNoBo6QcEMCKP9k",
      authDomain: "recibos-viagens.firebaseapp.com",
      projectId: "recibos-viagens",
      storageBucket: "recibos-viagens.firebasestorage.app",
      messagingSenderId: "449645669807",
      appId: "1:144562228077:web:08d166677cb809c0ee2864",
      measurementId: "G-V4CEC6Q2G6"
    };
    firebase.initializeApp(firebaseConfig);
  }
  
  // Pega as instâncias da autenticação e do banco de dados.
  const auth = firebase.auth();
  const db = firebase.firestore();
  const appId = firebase.app().options.appId;

  // --- ADIÇÃO IMPORTANTE ---
  // Define a persistência da autenticação para 'session'.
  // Isso significa que o login só dura enquanto a aba/janela do navegador estiver aberta.
  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
    .catch((error) => {
      // Loga um erro se não conseguir definir a persistência (raro)
      console.error("Erro ao definir a persistência da sessão:", error);
    });
  // --- FIM DA ADIÇÃO ---

  const container = document.getElementById('root');
  const root = createRoot(container);
  
  // Renderiza o App e entrega as conexões como "props".
  root.render(<App auth={auth} db={db} appId={appId} />);
}

checkForFirebase();